
export enum FormControlSize {
  SMALL = 'smallControl',
  MEDIUM = 'mediumControl',
  LARGE = 'largeControl',
}
